import years from '../data/vehicleYears';
import makes from '../data/vehicleMakes';
import models from '../data/vehicleModels';
//import { mmDDYYYY } from '../utils/placeHolderFormat';


function createList(data) {
    let returnList = [];
    data.forEach(element => {
        let replace = null;
        if (element === 'TOYOTA' || element === 'CHEVROLET') {
            replace = element === 'TOYOTA' ? 'TOYT' : 'CHEV';
        }
        returnList.push({
            code: replace ? replace : element,
            description: element
        });
    });
    return returnList;
}

let yearsList = createList(years);
let makeList = makes;
let modelList = createList(models);

console.log(makes);

const fields = [
    {
        type: "select",
        component: "select",
        label: "Year",
        name: "year",
        options: yearsList
    }, {
        type: "select",
        component: "select",
        label: "Make",
        name: "make",
        options: makeList
    }, {
        type: "select",
        component: "select",
        label: "Model",
        name: "model",
        options: modelList        
    }, {
        type: "select",
        component: "select",
        label: "Type",
        name: "vehicleType",
        options: [
            {
                "code": "SD",
                "description": "Sedan"
            }
        ]
    },
    {
        type: "text",
        component: "input",
        label: "vin",
        name: "vin"
    },
    /*
    {
        type: "text",
        component: "input",
        label: "dataSource",
        name: "dataSource"
    },
    {
        type: "text",
        component: "input",
        label: "isVehicleVerified",
        name: "isVehicleVerified"

    },
    {
        type: "text",
        component: "input",
        label: "isVehicleActiveDuringMostRecentTerm",
        name: "isVehicleActiveDuringMostRecentTerm"
    },
    {
        type: "text",
        component: "input",
        label: "vin",
        name: "vin"
    }, {
        type: "text",
        component: "input",
        label: "registeredOwnerName",
        name: "registeredOwnerName"
    }, {
        type: "text",
        component: "input",
        label: "nameTitle1",
        name: "nameTitle1"
    }, {
        type: "text",
        component: "input",
        label: "nameCode2",
        name: "nameCode2"
    }, 
    {
        type: "text",
        component: "input",
        label: "numberofVehicleOwners",
        name: "numberofVehicleOwners"
    }, {
        type: "text",
        component: "input",
        label: "classCode",
        name: "classCode"
    }, 
    
    {
        type: "text",
        component: "input",
        label: "collisionDeductibleAmount",
        name: "collisionDeductibleAmount"
    }, {
        type: "text",
        component: "input",
        label: "comprehensiveDeductibleAmount",
        name: "comprehensiveDeductibleAmount"
    }, 
    
    {
        type: "text",
        component: "input",
        placeholder:mmDDYYYY,
        label: "Insured since",
        name: "fromDate"
    }, 
    */
    /*
    {
        type: "text",
        component: "input",
        placeholder:mmDDYYYY,
        label: "Insurance expiration date",
        name: "toDate"
    },
    */ 
    {
        type: "radio",
        component: "input",
        label: "Has this vehicle been in a previous accident?",
        name: "collisionIndicator",
        options:[
            {
                code: 'Y',
                description: 'Yes'
            },
            {
                code: 'N',
                description: 'No'
            }            
        ]
    }, 
    {
        type:"text",
        component:"input",
        label: 'When did this incident occur?',
        name: 'accidentDate'
    },
    {
        type: "radio",
        component: "input",
        label: "Would you like Comprehensive Coverage on this vehicle?",
        name: "comprehensiveIndicator",
        options:[
            {
                code: 'Y',
                description: 'Yes'
            },
            {
                code: 'N',
                description: 'No'
            }            
        ]
    }, 
    /*
    {
        type: "text",
        component: "input",
        label: "coverages",
        name: "coverages"
    },
    
    {
        type: "text",
        component: "input",
        label: "What is your Bodily Injury coverage?",
        name: 'bodilyInjury'
    },
    {
        type: "text",
        component: "input",
        label: "What is your Property Damage coverage?",
        name: 'propertyDamage'
    },
    {
        type: "text",
        component: "input",
        label: "isVehicleSalvage",
        name: "isVehicleSalvage"
    }, 
    {
        type: "text",
        component: "input",
        label: "transactionDate",
        placeholder:mmDDYYYY,
        name: "transactionDate"
    },
    
    {
        type: "text",
        component: "input",
        label: "When does your current insurance expire?",
        placeholder:mmDDYYYY,
        name: "expirationDate"
    }, 
    {
        type: "text",
        component: "input",
        label: "activityDate",
        placeHolder: 'DD/MM',
        name: "activityDate"
    }
    */
   /*
    , {
        type: "text",
        component: "input",
        label: "lesseeLessor",
        name: "lesseeLessor"
    }, 
    {
        type: "text",
        component: "input",
        label: "documentType",
        name: "documentType"
    }, 
    
    {
        type: "text",
        component: "input",
        label: "isBranded",
        name: "isBranded"
    }, {
        type: "text",
        component: "input",
        label: "plateType",
        name: "plateType"
    }, {
        type: "text",
        component: "input",
        label: "isVINValid",
        name: "isVINValid"
    }, {
        type: "text",
        component: "input",
        label: "vinChangeIndicator",
        name: "vinChangeIndicator"
    }, {
        type: "text",
        component: "input",
        label: "vinCompare",
        name: "vinCompare"
    }, {
        type: "text",
        component: "input",
        label: "supplementalCatClaimIndicator",
        name: "supplementalCatClaimIndicator"
    }, 
    {
        type: "text",
        component: "input",
        label: "addresses",
        name: "addresses"
    },
    
    {
        label: 'Address',
        name: 'street1',
        type: 'text',
        component: 'input',
        placeHolder: 'Enter a location',
        validation: 'enter validation properties here'
    },
    {
        label: 'Apt #',
        name: 'aptNumber',
        type: 'text',
        component: 'input',
        placeHolder: '',
        validation: 'enter validation properties here'
    },
    {
        label: 'City',
        name: 'city',
        type: 'text',
        component: 'input',
        placeHolder: 'Enter a location',
        validation: 'enter validation properties here'
    },
    {
        label: 'State',
        name: 'stateCode',
        type: 'text',
        component: 'input',
        placeHolder: '',
        validation: 'enter validation properties here'
    },
    {
        label: 'Zip code',
        name: 'zip',
        type: 'text',
        component: 'input',
        placeHolder: '',
        validation: 'enter validation properties here'
    },    
    */ 
    {
        type: "text",
        component: "input",
        label: "State of registration",
        name: "stateOfRegistration"
    }, 
    /*
    {
        type: "text",
        component: "input",
        label: "reasonCodeDetails",
        name: "reasonCodeDetails"
    },
    
     {
        type: "text",
        component: "input",
        label: "actionMessages",
        name: "actionMessages"
    }, 
    */
    /*
    {
        type: "text",
        component: "input",
        label: "uniqueId",
        name: "uniqueId"
    }
    */
];


export default fields;


// WEBPACK FOOTER //
// ./src/Vehicle/fields.js